import React, { forwardRef, memo, useCallback, useImperativeHandle, useRef, useState, } from 'react';
import Cropper from 'react-easy-crop';
import Slider from '../slider';
import { ConfigContext } from '../config-provider';
import { INIT_ROTATE, INIT_ZOOM, MAX_ROTATE, MIN_ROTATE, ROTATE_STEP, ZOOM_STEP, } from './constants';
const EasyCrop = forwardRef((props, ref) => {
    const { cropperRef, image, aspect, shape, grid, zoom, rotate, minZoom, maxZoom, cropperProps, prefixCls: customPrefixCls, } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('imgcrop', customPrefixCls);
    const [crop, onCropChange] = useState({ x: 0, y: 0 });
    const [cropSize, setCropSize] = useState({ width: 0, height: 0 });
    const [zoomVal, setZoomVal] = useState(INIT_ZOOM);
    const [rotateVal, setRotateVal] = useState(INIT_ROTATE);
    const cropPixelsRef = useRef({ width: 0, height: 0, x: 0, y: 0 });
    const onMediaLoaded = useCallback((mediaSize) => {
        const { width, height } = mediaSize;
        const ratioWidth = height * aspect;
        if (width > ratioWidth) {
            setCropSize({ width: ratioWidth, height });
        }
        else {
            setCropSize({ width, height: width / aspect });
        }
    }, [aspect]);
    const onCropComplete = useCallback((_, croppedAreaPixels) => {
        cropPixelsRef.current = croppedAreaPixels;
    }, []);
    useImperativeHandle(ref, () => ({
        rotateVal,
        setZoomVal,
        setRotateVal,
        cropPixelsRef,
    }));
    return (<>
            <Cropper {...cropperProps} ref={cropperRef} image={image} crop={crop} cropSize={cropSize} onCropChange={onCropChange} aspect={aspect} cropShape={shape} showGrid={grid} zoomWithScroll={zoom} zoom={zoomVal} rotation={rotateVal} onZoomChange={setZoomVal} onRotationChange={setRotateVal} minZoom={minZoom} maxZoom={maxZoom} onMediaLoaded={onMediaLoaded} onCropComplete={onCropComplete} classes={{
            containerClassName: `${prefixCls}-container`,
            mediaClassName: `${prefixCls}-media`,
        }}/>
            {zoom && (<section className={`${prefixCls}-control ${prefixCls}-control-zoom`}>
                    <button onClick={() => setZoomVal(zoomVal - ZOOM_STEP)} disabled={zoomVal - ZOOM_STEP < minZoom}>
                        －
                    </button>
                    <Slider min={minZoom} max={maxZoom} step={ZOOM_STEP} value={zoomVal} onChange={setZoomVal}/>
                    <button onClick={() => setZoomVal(zoomVal + ZOOM_STEP)} disabled={zoomVal + ZOOM_STEP > maxZoom}>
                        ＋
                    </button>
                </section>)}
            {rotate && (<section className={`${prefixCls}-control ${prefixCls}-control-rotate`}>
                    <button onClick={() => setRotateVal(rotateVal - ROTATE_STEP)} disabled={rotateVal === MIN_ROTATE}>
                        ↺
                    </button>
                    <Slider min={MIN_ROTATE} max={MAX_ROTATE} step={ROTATE_STEP} value={rotateVal} onChange={setRotateVal}/>
                    <button onClick={() => setRotateVal(rotateVal + ROTATE_STEP)} disabled={rotateVal === MAX_ROTATE}>
                        ↻
                    </button>
                </section>)}
        </>);
});
export default memo(EasyCrop);
